import { render, staticRenderFns } from "./TxRowSkeletonMobile.vue?vue&type=template&id=78ca2758&scoped=true&functional=true"
var script = {}
import style0 from "./TxRowSkeletonMobile.vue?vue&type=style&index=0&id=78ca2758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "78ca2758",
  null
  
)

export default component.exports